// extracted by mini-css-extract-plugin
module.exports = {"splitSection":"SplitSection-module-split-section","preview":"SplitSection-module-preview"};